import React, { useContext, useState } from 'react'
import Box from '@mui/material/Box'
import { Button, TextField, Typography } from '@mui/material'
import { IncidentContext } from './ReportIncident'

const Step2 = () => {
  const { formValues, setFormValues, setTab } = useContext(IncidentContext)
  const [description, setDescription] = useState(formValues?.description ?? '')
  const [initialActions, setInitialActions] = useState(
    formValues?.initialActions ?? ''
  )

  const handleNext = (e) => {
    e.preventDefault()
    setFormValues((prev) => ({
      ...prev,
      description,
      initialActions,
    }))
    setTab((prev) => prev + 1)
    window.scrollTo(0, 0)
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      paddingY={2}
      component="form"
      onSubmit={handleNext}
    >
      <Typography variant="title2" fontSize="1rem">
        About the Incident
      </Typography>
      <TextField
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        multiline
        minRows={5}
        helperText="Please enter facts, not opinions. Do not enter names of people"
        label="Description of Incident"
        required
      />
      <TextField
        value={initialActions}
        onChange={(e) => setInitialActions(e.target.value)}
        multiline
        minRows={3}
        helperText="Enter the action taken at the time of the Incident"
        label="Initial Action Taken"
      />
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setTab((prev) => prev - 1)}
        >
          Previous
        </Button>
        <Button variant="contained" color="primary" type="submit">
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default Step2
